import { computed, type ComputedRef, type MaybeRef } from 'vue';

import type { AuctionItemEntity, DirectSaleItemEntity, SellingMethod } from '~/apiClient';
import type { AuctionItemEntityWithSellingMethod, DirectSaleItemEntityWithSellingMethod } from '~/types/sale.type';

type Raw<T extends SellingMethod> = T extends SellingMethod.Auction ? AuctionItemEntity : DirectSaleItemEntity;

type WithSellingMethod<T extends SellingMethod> = T extends SellingMethod.Auction
    ? AuctionItemEntityWithSellingMethod
    : DirectSaleItemEntityWithSellingMethod;

export function useSale(data: MaybeRef<undefined>, sellingMethod: undefined): { sale: ComputedRef<undefined> };

export function useSale<T extends SellingMethod>(data: MaybeRef<undefined>, sellingMethod: T): { sale: ComputedRef<undefined> };

export function useSale<T extends SellingMethod>(data: MaybeRef<Raw<T>>, sellingMethod: T): { sale: ComputedRef<WithSellingMethod<T>> };

export function useSale<T extends SellingMethod>(
    data: MaybeRef<Raw<T> | undefined>,
    sellingMethod: T | undefined
): { sale: ComputedRef<WithSellingMethod<T> | undefined> };

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useSale<T extends SellingMethod>(data: MaybeRef<Raw<T> | undefined>, sellingMethod: T | undefined) {
    const sale = computed(() => {
        if (!toValue(data) || !sellingMethod) return undefined;

        return {
            ...toValue(data),
            sellingMethod,
        } as WithSellingMethod<T>;
    });

    return { sale };
}
